import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const chapters = [
  {
    n: "01",
    title: "Diagnostics before repair.",
    body: "We start every visit with a full inspection — because guessing is expensive, and honesty is not.",
    tag: "Precision",
  },
  {
    n: "02",
    title: "Explained in plain English.",
    body: "You get photos, findings, and a straight recommendation. No jargon, no scare tactics — just what your vehicle actually needs.",
    tag: "Transparency",
  },
  {
    n: "03",
    title: "Built for daily drivers & fleets.",
    body: "From commuters to work trucks and small fleets, our shop is engineered to keep Birmingham moving on schedule.",
    tag: "Reliability",
  },
  {
    n: "04",
    title: "Backed by warranty.",
    body: "Industry-standard coverage on qualifying repairs, tires, and batteries — because standing behind our work is the whole job.",
    tag: "Assurance",
  },
];

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} className="abc-manifesto" aria-labelledby="manifesto-heading">
      <motion.div className="abc-manifesto-bg" style={{ y: bgY }} aria-hidden="true" />
      <div className="container abc-manifesto-inner">
        <header className="abc-manifesto-head">
          <span className="abc-mono-label">— The Standard</span>
          <h2 id="manifesto-heading" className="abc-manifesto-title">
            Four ideas that shape<br />every ticket we open.
          </h2>
        </header>

        <ol className="abc-manifesto-list">
          {chapters.map((c, i) => (
            <motion.li
              key={c.n}
              className="abc-chapter"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1], delay: i * 0.08 }}
            >
              <div className="abc-chapter-num">
                <span className="abc-chapter-num-big">{c.n}</span>
                <span className="abc-mono-label abc-chapter-tag">{c.tag}</span>
              </div>
              <div className="abc-chapter-body">
                <h3 className="abc-chapter-title">{c.title}</h3>
                <p className="abc-chapter-copy">{c.body}</p>
              </div>
              <div className="abc-chapter-rule" aria-hidden="true" />
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
